/* Look ahead Application
========================================================================== */

$(function() {

	/* Template */
	template.component.nav();
	template.component.search();
	template.component.element_link();
	template.component.easy_read_slider();
	// template.component.tabs();
	template.component.service_map();
	//template.component.request_repair_form();
	template.component.gravity_forms_override();
	template.component.form_validation();
	template.accordion();
	template.repeater_gallery();
	template.share_modal();
	template.component.fitvids();
	template.component.carousel();
	template.component.carousel2();
});

var resizeTimer;
var windowWidth = $(window).width();

$(window).resize(function() {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(function() {
		// Check window width has actually changed and it's not just iOS triggering a resize event on scroll
		if ($(window).width() !== windowWidth) {
			// Update the window width for next time
			windowWidth = $(window).width();

			template.component.nav();
			// template.component.tabs();
		}
	}, 250);
});